/**
 * Insert a placeholder into a Quill editor at the current cursor
 * (or at the end if there is no selection).
 */
export function insertQuillPlaceholder(quill, placeholder) {
  if (!quill || !placeholder) {
    return;
  }

  const range = quill.getSelection(true);
  if (range) {
    quill.insertText(range.index, placeholder);
    quill.setSelection(range.index + placeholder.length);
    return;
  }

  const length = quill.getLength();
  const index = Math.max(length - 1, 0);
  quill.insertText(index, placeholder);
  quill.setSelection(index + placeholder.length);
}
